const SET_PPA_IS_VISIBLE = 'SET_PPA_IS_VISIBLE';

export { SET_PPA_IS_VISIBLE };



// WEBPACK FOOTER //
// ./src/containers/Inputs/PPA/constants.js